<template>
  <AuthLayout class="page-auth">
    <form action="#" @submit.prevent="submit">
      <input type="email" :placeholder="$t('e-mail')" v-model="email" required />
      <input type="password" :placeholder="$t('password')" v-model="password" required />
      <input type="password" :placeholder="$t('PasswordReset.confirmPassword')" v-model="confirmPassword" required />

      <terms required />

      <div class="page-auth__actions">
        <button class="primary large" type="submit">{{ $t('PasswordReset.changePassword') }}</button>
        <router-link to="/auth">
          <button class="white large" type="button">{{ $t('logIn') }}</button>
        </router-link>
      </div>

      <div class="error-block" v-if="errors.length">
        <p v-for="error in errors" :key="error">
          {{ error }}
        </p>
      </div>
      <div class="message-block" v-if="messages.length">
        <p v-for="message in messages" :key="message">
          {{ message }}
        </p>
      </div>

      <div class="page-forgot__link">
        {{ $t('PasswordReset.forgot') }}
        <router-link to="/sign-up">{{ $t('singUp') }}</router-link>
      </div>
    </form>
  </AuthLayout>
</template>

<script>
import AuthLayout from '@/components/auth/Authlayout'
import { APP_API_BASE } from '../const/api'

export default {
  name: 'PasswordReset',
  components: { AuthLayout },
  data: () => ({
    email: '',
    password: '',
    confirmPassword: '',
    errors: [],
    messages: [],
  }),
  methods: {
    submit() {
      this.errors = []
      this.messages = []

      if (this.password !== this.confirmPassword) {
        this.errors.push(this.$t('PasswordReset.submitError'))
        return
      }

      fetch(APP_API_BASE + '/api/password/reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          email: this.email,
          password: this.password,
          password_confirmation: this.confirmPassword,
          token: this.$route.params.token,
        }),
      })
        .then(async (response) => {
          if (!response.ok) {
            return Promise.reject(response)
          }

          return response.json()
        })
        .then((responseData) => {
          this.messages.push(responseData.message)
        })
        .catch((response) => {
          if (response.status === 413) {
            this.errors.push(this.$t('PasswordReset.error413'))
          }

          return response.json().then(
            (errorData) => {
              console.log(errorData)
              if (errorData?.hasOwnProperty('errors')) {
                for (let field in errorData.errors) {
                  for (let i = 0; i < errorData.errors[field].length; i++) {
                    this.errors.push(errorData.errors[field][i])
                  }
                }
              } else {
                this.errors.push(this.$t('PasswordReset.serverError'))
              }
            },
            (rejectData) => {
              console.log(rejectData)
            }
          )
        })
    },
  },
}
</script>

<style lang="scss">
.page-forgot {
  &__link {
    margin-top: 20px;
  }
}
</style>
